/**
 * The repository index (YAG-831): one record per workspace repository saying
 * what it is for, what it is written in, which runtimes and variables it
 * needs, a suggested install, its private dependencies, which installation
 * origins a build sandbox can and cannot reach, and which of its checks a
 * sandbox can run. Mirrors the `repo_index` row in camelCase.
 */
import { z } from "zod";
import { variableName } from "./qaEnvironmentSchema.js";
import { REPO_ROLE_REASON_MAX, repoRoleSchema, } from "./repoRelations.js";
export const REPO_INDEX_STATUSES = ["pending", "indexed", "failed"];
export const REPO_INDEX_DESCRIPTION_MAX = 300;
export const REPO_INDEX_VARIABLES_MAX = 100;
/** The structured output of the `repo.index` model call. */
export const repoIndexModelOutputSchema = z.object({
    description: z.string().max(REPO_INDEX_DESCRIPTION_MAX),
    language: z.string().max(100).optional(),
    variables: z
        .array(z.object({
        name: variableName,
        required: z.boolean().nullable(),
        meaning: z.string().max(200).nullable(),
        source: z.literal("readme").optional(),
    }))
        .max(REPO_INDEX_VARIABLES_MAX),
});
/**
 * The role the `repo.index` model read (YAG-1067), parsed apart from
 * {@link repoIndexModelOutputSchema} and leniently: an unknown role is
 * dropped and a long reason is cut, so a bad role never costs the
 * description and variables. Never fails.
 */
export const repoIndexModelRoleSchema = z
    .object({
    role: repoRoleSchema.optional().catch(undefined),
    roleReason: z
        .string()
        .transform((reason) => reason.replace(/\s+/g, " ").trim().slice(0, REPO_ROLE_REASON_MAX))
        .optional()
        .catch(undefined),
})
    .catch({});
//# sourceMappingURL=repoIndex.js.map